// ═══════════════════════════════════════════════════════════════════════════
// Block-lifecycle AI translators (PURGE_BLOCKS / RENAME_BLOCK).
// ═══════════════════════════════════════════════════════════════════════════

import type { EditorCommand } from "@dxf-ai-editor/contracts";

import type {
  PurgeBlocksAiCommand,
  RenameBlockAiCommand,
} from "./blockSchemas";
import { AI_COMMAND_SOURCE } from "./blockDispatcherShared";

export function translatePurgeBlocks(
  command: PurgeBlocksAiCommand,
): EditorCommand[] {
  return [
    {
      type: "file/purge-blocks",
      source: AI_COMMAND_SOURCE,
      blockNames: command.blockNames,
    },
  ];
}

export function translateRenameBlock(
  command: RenameBlockAiCommand,
): EditorCommand[] {
  return [
    {
      type: "file/rename-block",
      source: AI_COMMAND_SOURCE,
      oldName: command.oldName,
      newName: command.newName,
    },
  ];
}
